import wrapError from "@/components/helpers/wrapError"
import wrapSuccess from "@/components/helpers/wrapSuccess"

export const apiAccessRequestAddMember = (accessRequestId, constituent, success, error) => {
  $.ajax({
    type: "POST",
    url: `/api/admin/networkAccessRequest/${accessRequestId}`,
    success,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ resolutionType: "addMember", constituent }),
    error: wrapError(error, "apiAccessRequestAddMember"),
  })
}

export const apiAccessRequestGrantAccess = (accessRequestId, constituentId, success, error) => {
  $.ajax({
    type: "POST",
    url: `/api/admin/networkAccessRequest/${accessRequestId}`,
    success,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ resolutionType: "grantAccess", constituentId }),
    error: wrapError(error, "apiAccessRequestGrantAccess"),
  })
}

export const apiDenyRequest = (accessRequestId, success, error) => {
  $.ajax({
    type: "POST",
    url: `/api/admin/networkAccessRequest/${accessRequestId}`,
    success,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ resolutionType: "denyRequest" }),
    error: wrapError(error, "apiDenyRequest"),
  })
}

export const apiFetchNetworkAccessRequests = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/admin/networkRequestList",
    success,
    error: wrapError(error, "apiFetchNetworkAccessRequests"),
  })
}

export const apiFetchPossibleMatches = (accessRequestId, funcToDispatch, error, callback) => {
  $.ajax({
    type: "GET",
    url: `/api/admin/networkAccessRequest/${accessRequestId}`,
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiFetchPossibleMatches"),
  })
}

export const apiGetMagicPassword = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/admin/magicPassword",
    success,
    error: wrapError(error, "apiMagicPassword"),
  })
}

export const apiUpdateMagicPassword = (magicPassword, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/magicPassword",
    success,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ magicPassword }),
    error: wrapError(error, "apiUpdateMagicPassword"),
  })
}

export const resendOnboardingEmail = (constituentId, success, error) => {
  $.ajax({
    type: "POST",
    url: `/api/admin/resendOnboardingManager/${constituentId}`,
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    success,
    data: JSON.stringify({}),
    error: wrapError(error, "resendOnboardingEmail"),
  })
}

export const apiAddConstituent = (constituent, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/addMemberManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(constituent),
    success,
    error: wrapError(error, "apiAddConstituent"),
  })
}
